import { Divider, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer.tsx";
import { useAppDispatch } from "../../../../store/hooks/useAppDispatch.ts";
import { selectFinancialStatementSettings } from "../../../../store/selectors/fieldsStateSelectors.ts";
import { createFinancialStatementAction } from "../../../../store/utils/storeUtils.ts";
import CheckboxField from "../../../common/CheckboxField.tsx";
import SwitchField from "../../../common/SwitchField.tsx";
import { getHideBlankRowsSettingsChanges } from "../utils/statementSettings.ts";

interface Props {
  readonlyMode: boolean;
}

const FinancialStatementSettingsContainer = ({ readonlyMode }: Props) => {
  const dispatch = useAppDispatch();
  const settings = useSelector(selectFinancialStatementSettings);
  const hideBlankRows = settings.hideBlankRows === true;

  return (
    <ScrollableFlexContainer>
      <Stack spacing={1.5} sx={{ px: "1.3rem", width: "100%" }}>
        <Stack spacing={1.5} sx={{ pb: 1.5 }}>
          <Typography variant="subtitle1">General</Typography>
          <Stack>
            <SwitchField
              label="Hide Blank Rows"
              checked={hideBlankRows}
              onChange={(value) =>
                dispatch(createFinancialStatementAction("updateSettings", getHideBlankRowsSettingsChanges(value)))
              }
              containerSx={{ py: 0.75 }}
              disabled={readonlyMode}
            />
            {hideBlankRows && (
              <CheckboxField
                checked={settings.hideZeroRows === true}
                onChange={(value) =>
                  dispatch(createFinancialStatementAction("updateSettings", { hideZeroRows: value }))
                }
                label="Treat Zeros as Empty"
                formControlLabelSx={{ ml: 1.25 }}
                disabled={readonlyMode}
              />
            )}
            <SwitchField
              label="Highlight the Actual Period"
              checked={settings.highlightPeriod === true}
              onChange={(value) =>
                dispatch(createFinancialStatementAction("updateSettings", { highlightPeriod: value }))
              }
              containerSx={{ py: 0.75 }}
              disabled={readonlyMode}
            />
            <SwitchField
              label="Show Negative Values in Red"
              checked={settings.showNegativesInRed !== false}
              onChange={(value) =>
                dispatch(createFinancialStatementAction("updateSettings", { showNegativesInRed: value }))
              }
              containerSx={{ py: 0.75 }}
              disabled={readonlyMode}
            />
          </Stack>
          <Divider sx={{ borderStyle: "dashed" }} />
          <Typography variant="subtitle1">Totals</Typography>
          <SwitchField
            label="Show Rows Grand Total"
            checked={settings.showRowsGrandTotal === true}
            onChange={(value) =>
              dispatch(createFinancialStatementAction("updateSettings", { showRowsGrandTotal: value }))
            }
            disabled={readonlyMode}
          />
        </Stack>
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default FinancialStatementSettingsContainer;
